import { auth } from '../firebase/config';

const paymentService = {
    createPaymentIntent: async (eventId) => {
        const user = auth.currentUser;
        if (!user) throw new Error("User not authenticated");
        
        const token = await user.getIdToken();
        
        const response = await fetch('/api/create-payment-intent', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ eventId })
        });
        
        if (!response.ok) {
            const error = await response.json().catch(() => ({ message: 'Error creating payment intent' }));
            throw new Error(error.message || 'Payment server error');
        }
        
        return response.json();
    },
};

export default paymentService;
